export default {
  aiChatTutorMessageSent: 'aiChatTutorMessageSent'
}
